import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import AnomalyGuidesPage from "./ui";

const AnomalyGuides = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <AnomalyGuidesPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default AnomalyGuides;
